import React, { useContext } from 'react';
import { toKebabCase } from '../../../utils/format';
import { CioAutocompleteContext } from '../CioAutocompleteProvider';
import SectionItemsList from '../SectionItemsList/SectionItemsList';
import CloseIcon from './CloseIcon';
const DefaultRenderResults = ({ sections }) => sections?.map((section) => {
    const { type } = section;
    let key = section.displayName;
    switch (type) {
        case 'recommendations':
            key = section.podId;
            break;
        case 'custom':
            key = toKebabCase(section.displayName);
            break;
        case 'autocomplete':
            key = section.indexSectionName;
            break;
        default:
            key = section.indexSectionName;
            break;
    }
    return React.createElement(SectionItemsList, { section: section, key: key });
});
export default function AutocompleteResults(props) {
    const { children = DefaultRenderResults } = props;
    const { sections, isOpen, getMenuProps, getItemProps, closeMenu } = useContext(CioAutocompleteContext);
    const hasResults = sections && sections.some((section) => section?.data?.length);
    const menuProps = {
        ...getMenuProps(),
    };
    let content;
    if (isOpen && hasResults) {
        content = (React.createElement(React.Fragment, null,
            React.createElement(CloseIcon, { onClick: () => closeMenu() }),
            typeof children === 'function' ? children({ sections, getItemProps }) : children));
    }
    else {
        content = null;
        menuProps.style = {
            display: 'none',
        };
    }
    return React.createElement("ul", { ...menuProps }, content);
}
